// extracted by mini-css-extract-plugin
export default {"title":"u5-z","warning":"v5-z","sizeOptionsLegendText":"w5-z"};